export const isEmptyTableCellValue = (value: unknown): boolean => {
  if (value === null || value === undefined) return true
  if (typeof value === 'string') return value.trim() === ''
  if (Array.isArray(value)) return value.length === 0
  return false
}

export const tableCellValueOrDash = <T>(value: T): T | '-' =>
  isEmptyTableCellValue(value) ? '-' : value
